import * as Three from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import * as dat from "lil-gui";
import gsap from "gsap";
import sunImage from "/sun2.png";
import mercuy from "/mercuy.png";
import venus from "/venus.png";
import earth from "/earth.jpg";
import mars from "/mars.png";
import jupiter from "/jupiter.jpg";
import saturn from "/saturn.png";
import uranus from "/uranus.jpg";
import neptun from "/neptun.jpg";

//import canvas
const canvas = document.getElementById("canvas");
const bar = document.querySelector(".bar");
const loadingLayer = document.querySelector(".loading");

const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}

const loadingManager = new Three.LoadingManager();

loadingManager.onProgress = (e, itemsLoaded, itemsTotal) => {
  const progressRatio = itemsLoaded / itemsTotal;
  bar.style.transform = `scaleX(${progressRatio})`;
  if (progressRatio == 1) {
    loadingLayer.style.display = "none";
    gsap.to(camera.position, { duration: 1, z: 40 });
  }
};

const textureLoader = new Three.TextureLoader(loadingManager);

const sunTexture = textureLoader.load(sunImage);
const mercuyTexture = textureLoader.load(mercuy);
const venusTexture = textureLoader.load(venus);
const earthTexture = textureLoader.load(earth);
const marsTexture = textureLoader.load(mars);
const jupiterTexture = textureLoader.load(jupiter);
const saturnTexture = textureLoader.load(saturn);
const uranusTexture = textureLoader.load(uranus);
const neptunTexture = textureLoader.load(neptun);

sunTexture.repeat.x = 2;
sunTexture.repeat.y = 3;
sunTexture.wrapS = Three.MirroredRepeatWrapping;
sunTexture.wrapT = Three.MirroredRepeatWrapping;
//create scene
const scene = new Three.Scene();

//axis helpers
// const helpers = new Three.AxesHelper();
// scene.add(helpers);
//create camera
const camera = new Three.PerspectiveCamera(75, sizes.width / sizes.height);
camera.position.z = 0;
camera.position.y = 40;
camera.position.x = 40;

scene.add(camera);

//create controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
controls.maxDistance = 150;
controls.autoRotate = true;
controls.autoRotateSpeed = -1;
controls.update();

window.onresize = () => {
  //update size
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  //update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  if (window.innerWidth < 700) {
    gsap.to(camera.position, { duration: 1, z: 80 });
    controls.minDistance = 20;
    controls.update();
  } else {
    controls.minDistance = 10;
    controls.update();
  }
  //update renderer
  renderer.setSize(sizes.width, sizes.height);
};

//responsive
if (window.innerWidth < 700) {
  gsap.to(camera.position, { duration: 1, z: 80 });
  controls.minDistance = 20;
  controls.update();
} else {
  controls.minDistance = 10;
  controls.update();
}

////////create sphere///////
function CreateSphere(pos, size, texture) {
  this.sphereGeometry = new Three.SphereGeometry();
  this.sphereMaterial = new Three.MeshBasicMaterial({
    //color: 0xff0000,
    map: texture,
  });

  this.sphere = new Three.Mesh(this.sphereGeometry, this.sphereMaterial);
  this.sphere.position.x = pos;
  this.sphere.scale.x = size;
  this.sphere.scale.y = size;
  this.sphere.scale.z = size;

  scene.add(this.sphere);

  this.animate = function () {
    console.log("fjsdl");
  };
}

//create stars
const starGeometry = new Three.SphereGeometry(0.1);
const starMaterial = new Three.MeshBasicMaterial();

//create circle

const circleGeometry = new Three.RingGeometry(13.1, 13, 100);
const circleMaterial = new Three.MeshBasicMaterial({
  side: Three.DoubleSide,
  color: 0xe8e8e880,
  transparent: true,
  opacity: 0.2,
});

const spheresArray = [];
const plantesSizes = [4, 2.5, 3, 3.5, 4.5, 5, 3, 2.5, 2];
const texturesArr = [
  sunTexture,
  mercuyTexture,
  venusTexture,
  earthTexture,
  marsTexture,
  jupiterTexture,
  saturnTexture,
  uranusTexture,
  neptunTexture,
];

for (let i = 0; i < 9; i++) {
  const circle = new Three.Mesh(circleGeometry, circleMaterial);
  circle.rotation.x = Math.PI / 2;
  circle.scale.x = 0.92 * i;
  circle.scale.y = 0.92 * i;
  scene.add(circle);

  spheresArray.push({
    geo: new CreateSphere(i * 6, plantesSizes[i], texturesArr[i]),
    pos: i * 6,
    speed: getRandomArbitrary(0.1, 0.6),
  });
}

for (let i = 0; i < 800; i++) {
  const star = new Three.Mesh(starGeometry, starMaterial);
  star.position.x = getRandomInt(-150, 150);
  star.position.y = getRandomInt(-150, 150);
  star.position.z = getRandomInt(-150, 150);
  scene.add(star);
}

//render
const renderer = new Three.WebGLRenderer({
  canvas: canvas,
});

renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

//refresh screen each frame

const clock = new Three.Clock();

const updateScreen = () => {
  const elapsedTime = clock.getElapsedTime();

  for (let i = 0; i < spheresArray.length; i++) {
    if (i == 0) {
      spheresArray[i].geo.sphere.position.x = 0;
      spheresArray[i].geo.sphere.position.z = 0;
    } else {
      spheresArray[i].geo.sphere.position.x =
        Math.cos(
          elapsedTime * (1 / spheresArray[i].pos + spheresArray[i].speed)
        ) *
        (spheresArray[i].pos + spheresArray[i].pos);
      spheresArray[i].geo.sphere.position.z =
        Math.sin(
          elapsedTime * (1 / spheresArray[i].pos + spheresArray[i].speed)
        ) *
        (spheresArray[i].pos + spheresArray[i].pos);
    }
  }
  //   spheresArray[1].sphere.position.x = Math.cos(elapsedTime) * 4;
  //   spheresArray[1].sphere.position.z = Math.sin(elapsedTime) * 4;

  //   spheresArray[2].sphere.position.x = Math.cos(elapsedTime * 0.5) * 8;
  //   spheresArray[2].sphere.position.z = Math.sin(elapsedTime * 0.5) * 8;

  controls.update();
  renderer.render(scene, camera);
  requestAnimationFrame(updateScreen);
};

updateScreen();

//create gui
// const gui = new dat.GUI();

// gui.add(camera.rotation, "x", -2 * Math.PI, 2 * Math.PI, 0.1);
// gui.add(mesh.scale, "x", 0, 100);
// gui.add(mesh.scale, "z", 0, 100);
// gui.add(mesh.scale, "y", 0, 100);
